import HttpRequest from "@/api/axios";
import {host} from "@/configs/config";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    getCertType(data) {
        return axios.request({
            url: "api/cert-type",
            method: "post",
            data
        });
    },
    wxLoginWap(data) {
        return axios.request({
            url: "user/login-wx-wap",
            method: "post",
            data
        });
    },
    appLaunch() {
        return axios.request({
            url: "api/launch"
        })
    },
    sendnotice(data) {
        return axios.request({
            url: "api/send-notice",
            method: "post",
            data
        })
    },
    noticeView(data) {
        return axios.request({
            url: "api/notice-view",
            method: "post",
            data
        })
    },
    getProduct(data){
      return axios.request({
          url: "product/list",
          method: "get",
          data
      })
    },
    getProductDetail(data){
        return axios.request({
            url: "product/detail",
            method: "post",
            data
        })
    },
    getCates(data){
        return axios.request({
            url: "product/cates",
            method: "post",
            data
        })
    },
    getBanner(data){
        return axios.request({
            url: "rf-article/adv/index",
            method: "get",
            data
        })
    },

//上传文件
    uploadfile(file,imgkey="file")
    {
        let formData = new FormData();
        formData.append(imgkey,file.file);
        var token = localStorage.getItem('token');
        return axios.request({
            url: "v1/file/images",
            method: "post",
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
                'access-token': token,
            },
            transformRequest: [
                function (data) {
                    return data
                }
            ],
            timeout: 10e4
        })
    },
    upload({content, imgkey}) {

        var formData = new FormData();
        var arr = content.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        if (!imgkey) imgkey = 'myfile'
        let mime2siffix = {
            'video/x-msvideo': 'avi',
            'video/x-dv': 'dv',
            'video/quicktime': 'mov',
            'video/x-ms-wmv': 'wm',
            'video/x-flv': 'flv',
            'video/x-matroska': 'mkv'
        };
        let suffix = mime2siffix[mime]
        if (!suffix) suffix = mime.split('/')[1]

        formData.append(imgkey, new File([u8arr], `${imgkey}.${suffix}`, {type: mime}));
        formData.append("imgkey", imgkey);
        formData.append("name", imgkey);


        return axios.request({
            url: "api/fileupload",
            method: "post",
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            transformRequest: [
                function (data) {
                    return data
                }
            ],
            timeout: 10e4
        })
    },
    getVersion(){
        return axios.request({
            baseURL: "",
            url: `/static/json/version.json?v=${new Date().getTime().toString()}`,
            method: "get",
            data:{'api_throw_exception':false}
        })
    },
    getZlist(data){
        return axios.request({
            url: "article",
            method: "get",
            data
        })
    },
    getSign(data){
        return axios.request({
            url: "rf-article/article-single/view",
            method: "get",
            data
        })
    },
    uploadidcard(data){
        return axios.request({
            url: "v1/file/idcard",
            method: "post",
            data
        })
    },
    edu(data){
        return axios.request({
            url: "user/edu",
            method: "post",
            data
        })
    },
    achievement(data){
        return axios.request({
            url: "user/resume-achievement",
            method: "post",
            data
        })
    },
    info(data){
        return axios.request({
            url: "user/info",
            method: "post",
            data
        })
    },
    baseinfo(data){
        return axios.request({
            url: "user/base-info",
            method: "post",
            data
        })
    },
    jobList(data)
    {
        return axios.request({
            url: "jobs/list",
            data
        })
    },
    certsave(data)
    {
        return axios.request({
            url: "api/user/cert-save",
            data
        })
    },
    getZlistdetail(data)
    {
        return axios.request({
            url: "article/view",
            data
        })
    },
    subOder(data)
    {
        return axios.request({
            url: "apply-order/invoice",
            method: "post",
            data
        })
    }
}
